// Current copy follows the supplied product poster; video labels follow the existing films.
export const heroContent = {
  eyebrow: '专为科研人打造的 AI 科研助手',
  terminology: '专业术语识别度更高',
  reasoning: '学术推理更严谨',
  retrieval: '依托上亿篇学术论文库做领域 RAG 增强',
  evidence: '降低科研幻觉，专业推理能力更强',
  fields: '适配纳米材料、半导体、能源、生物医学等方向',
};
export const capabilities = [
  ['学术级科研问答', 'research-qa', 'qa'],
  ['可溯源文献引用', 'citation', 'citation'],
  ['智能文献管理', 'literature', 'literature'],
  ['论文综述辅助写作', 'writing', 'writing'],
  ['实验图像与数据智能解析', 'analysis', 'analysis'],
  ['科研仪器智能辅助', 'instrument', 'instrument'],
];
export const videos = [
  { id: 'qa', title: '学术级科研问答', duration: 24 },
  { id: 'citation', title: '可溯源文献引用', duration: 29 },
  { id: 'literature', title: '智能文献管理', duration: 21 },
  { id: 'writing', title: '论文综述辅助写作', duration: 27 },
  { id: 'analysis', title: '实验图像与数据智能解析', duration: 27 },
  { id: 'instrument', title: '科研仪器智能辅助', duration: 27 },
];
